import { combineReducers } from 'redux';
import pinPlateRequestsReducer from './duplicate-pin-plate-admin-search/reducer/pinPlateMappedReducer';

export const pinPlateRequestsCombineReducer = () => combineReducers({
    pinPlateRequests: pinPlateRequestsReducer,

});
